<template>
  <PageFaq
    :faq-categories = "faqCategories"
    :faq-questions = "faqQuestions"/>
</template>

<script>
import AppRouteMixin from '~/mixins/AppRouteMixin'
import PageFaq from '@theme/components/content/PageFaq'
import gql from 'graphql-tag'
import processContentBuilder from '~/app/processContentBuilder'
import slugify from 'slugify'

const PAGE = {
  name: 'RouteFaq',
  nuxtI18n: {
    paths: {
      cs: '/nejcastejsi-dotazy',
      de: '/faq',
      en: '/faq',
      sk: '/najcastejsie-otazky',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PageFaq,
  },
  mixins: [AppRouteMixin],
  async asyncData({ app, store, query, redirect, route, res }) {
    if (process.server) {
      res.set('X-Inspishop-Cache-Control', `public, max-age=${app.$env.STATELESS_TTL}`)
    }
    let client = app.apolloProvider.defaultClient
    const result = await client.query({
      query: gql`
        query {
          faq_category {
            entities {
              title
              _id
            }
          }
          faq_question {
            entities {
              _id
              content
              faq_categories_reference {
                entityId
              }
              title
            }
          }
        }
      `,
    })
    result.data.faq_category.entities.forEach(i => (i.title ? (i.slug = slugify(i.title, { lower: true })) : ''))
    result.data.faq_question.entities.forEach(i => (i.title ? (i.slug = slugify(i.title, { lower: true })) : ''))
    const promises = []
    result.data.faq_question.entities.forEach(question => {
      promises.push(
        processContentBuilder(question.content, store.dispatch).then(result => {
          question.content = result
        }),
      )
    })
    await Promise.all(promises)
    store.commit('locale/SET_CANONICALS')
    return {
      faqCategories: result.data.faq_category.entities,
      faqQuestions: result.data.faq_question.entities,
    }
  },
}
export default PAGE
</script>
